var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"tw-empty"},[_c('v-uni-image',{staticClass:"image",attrs:{"src":_vm.src}}),(_vm.msg1)?_c('v-uni-view',{staticClass:"label-big"},[_vm._v(_vm._s(_vm.msg1))]):_vm._e(),(_vm.msg2)?_c('v-uni-view',{staticClass:"label-small"},[_vm._v(_vm._s(_vm.msg2))]):_vm._e(),_vm._t("default")],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }